module.exports = __webpack_public_path__ + "img/advanced-material-processing.4a57cd9c.png";